import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { getData } from 'features/dinamic';
import { setDataToast, setVisibleToast } from 'features/toast';
import AlertInterface from 'features/toast/toastInterface';

interface FacilitadorResultadoState {
  statusCiclo: string;
  statusModulo: string;
  statusActualizar: string;
  error: string;
  resultadosCiclo: any | null;
  resultadosModulo: any | null;
}

const initialState: FacilitadorResultadoState = {
  statusCiclo: 'idle',
  statusModulo: 'idle',
  statusActualizar: 'idle',
  error: '',
  resultadosCiclo: null,
  resultadosModulo: null,
};

export const fetchResultadosCiclo = createAsyncThunk(
  'facilitador/fetchResultadosCiclo',
  async ({ idCiclo }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 144;
    const { result, message, data } = await getData({ idsp, idCiclo }, getState, dispatch);
    if (result) {
      return { data };
    }
    return rejectWithValue(message);
  }
);

export const fetchResultadosModulo = createAsyncThunk(
  'facilitador/fetchResultadosModulo',
  async ({ idModulo, idGrupo }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 145;
    const { result, message, data } = await getData({ idsp, idModulo, idGrupo }, getState, dispatch);
    if (result) {
      return { data };
    }
    return rejectWithValue(message);
  }
);

export const updateResultadoManual = createAsyncThunk(
  'facilitador/updateResultadoManual',
  async (
    { idAlumnoDiplomadoResultado, notaFinal, porcentajeAsistenciaGlobal, observaciones, idCiclo }: any,
    { dispatch, getState, rejectWithValue }
  ) => {
    const idsp = 148;
    let alert: AlertInterface;
    const { result, message, data } = await getData(
      { idsp, idAlumnoDiplomadoResultado, notaFinal, porcentajeAsistenciaGlobal, observaciones },
      getState,
      dispatch
    );

    if (result) {
      alert = { title: 'CORRECTO..!', message, data: [], type: 'LimeGreen', time: Date.now() };
    } else {
      alert = { title: 'ACCIÓN INCOMPLETA', message, data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    setTimeout(() => {
      dispatch(setVisibleToast(false));
    }, 4000);

    if (result && idCiclo) {
      dispatch(fetchResultadosCiclo({ idCiclo }));
    }

    if (result) {
      return { data };
    }
    return rejectWithValue(message);
  }
);

const facilitadorResultadoSlice = createSlice({
  name: 'facilitadorResultado',
  initialState,
  reducers: {
    clearResultados: (state) => {
      state.resultadosCiclo = null;
      state.resultadosModulo = null;
      state.statusCiclo = 'idle';
      state.statusModulo = 'idle';
      state.statusActualizar = 'idle';
      state.error = '';
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchResultadosCiclo.pending, (state) => {
        state.statusCiclo = 'loading';
      })
      .addCase(fetchResultadosCiclo.fulfilled, (state, action) => {
        state.statusCiclo = 'completed';
        state.resultadosCiclo = action.payload.data || null;
      })
      .addCase(fetchResultadosCiclo.rejected, (state, action) => {
        state.statusCiclo = 'failed';
        state.error = action.payload as string;
      })
      .addCase(fetchResultadosModulo.pending, (state) => {
        state.statusModulo = 'loading';
      })
      .addCase(fetchResultadosModulo.fulfilled, (state, action) => {
        state.statusModulo = 'completed';
        state.resultadosModulo = action.payload.data || null;
      })
      .addCase(fetchResultadosModulo.rejected, (state, action) => {
        state.statusModulo = 'failed';
        state.error = action.payload as string;
      })
      .addCase(updateResultadoManual.pending, (state) => {
        state.statusActualizar = 'loading';
      })
      .addCase(updateResultadoManual.fulfilled, (state) => {
        state.statusActualizar = 'completed';
      })
      .addCase(updateResultadoManual.rejected, (state, action) => {
        state.statusActualizar = 'failed';
        state.error = action.payload as string;
      });
  },
});

export const selectFacilitadorResultadosCiclo = (state: RootState) => state.facilitadorResultado.resultadosCiclo;
export const selectFacilitadorResultadosModulo = (state: RootState) => state.facilitadorResultado.resultadosModulo;
export const selectFacilitadorResultadosCicloStatus = (state: RootState) => state.facilitadorResultado.statusCiclo;
export const selectFacilitadorResultadosModuloStatus = (state: RootState) => state.facilitadorResultado.statusModulo;
export const selectFacilitadorResultadosActualizarStatus = (state: RootState) =>
  state.facilitadorResultado.statusActualizar;

export const { clearResultados } = facilitadorResultadoSlice.actions;

export default facilitadorResultadoSlice.reducer;
